import React from "react";

import SectionTitleSpecial from "../../../components/SectionTitle/SectionTitleSpecial";
import shapeImg2 from "../../../assets/img/about/ed-shape-1-1.png";
import aboutImg1 from "../../../assets/img/sap/aboutus01.png";
import aboutImg3 from "../../../assets/img/sap/aboutus02.png";
import aboutImg2 from "../../../assets/img/sap/aboutus03.png";

const MissionSection = () => {
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-xxl-11 col-xl-10 col-lg-10">
          <div className="postbox__details-wrapper pt-50 pb-0">
            <div className="postbox__item text-center pb-0 pb-md-5">
              <i className="fas fa-quote-right"></i>
              <p>
                The Society of Aquaculture Professional (SAP) is a non-profit,
                non-government organization established for and by a group of
                aquaculture professionals, in India, in the year 2003.
                Currently, SAP has over 600+ aquaculture professionals as life
                members. Aqua India is the biannual conference conducted by SAP
                and attended by well over 600 aquaculture professionals from
                India and abroad.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="it-about" className="it-about-3-area fix pt-0 pb-50 p-relative">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-xl-6 col-lg-6 wow animate__fadeInLeft"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div className="ed-about-thumb-box p-relative">
                <div className="ed-about-thumb-1">
                  <img src={aboutImg1} alt="" />
                </div>
                <div className="ed-about-thumb-2">
                  <img src={aboutImg2} alt="" />
                </div>
                <div className="ed-about-thumb-3">
                  <img src={aboutImg3} alt="" />
                </div>
                <div className="ed-about-shape-1 d-none d-md-block">
                  <img src={shapeImg2} alt="" />
                </div>
                <div className="ed-about-experience d-none d-md-block">
                  <span>
                    <b>21+</b> <br />
                    Years Of <br />
                    Experiences
                  </span>
                </div>
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 wow animate__fadeInRight"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <div className="it-about-3-title-box">
                <SectionTitleSpecial
                  itemClass="it-about-title-box mb-20 section-title-fixed-width"
                  subTitle="OUR MISSION"
                  preTitle="Mission Of Society Of Aquaculture"
                  highlightText="Professional"
                />
                <p>
                  To help aquaculture professionals advance the art science and
                  practice of aquaculture. This is to be achieved by providing
                  opportunities for continuous professional development of
                  individuals and being the voice of professionals to all
                  stakeholders in the aquaculture industry.
                </p>
              </div>
              <div className="it-about-3-mv-box">
                <div className="row">
                  <div className="col-xl-12 col-md-12">
                    <div className="it-about-3-mv-item">
                      <span className="it-about-3-mv-title">Objectives</span>
                      <div className="col-xl-12 col-md-12">
                        <div className="it-about-4-list-wrap d-flex align-items-start">
                          <div className="it-about-5-list">
                            <ul style={{ backgroundColor: "transparent" }}>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Promote the art, science and practice of
                                aquaculture as an important and sustainable
                                technology to produce food.
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Foster advancements in aquaculture science and
                                technology through research.
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Help educational institutions to offer relevant
                                and practical aquaculture education.
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Gather and disseminate scientific, technical and
                                other information about aquaculture through
                                publications, meetings and other forms of
                                communication.
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Develop and keep updated a set of technical and
                                ethical standards for aquaculture professionals.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MissionSection;
